import { OWNER_PW_KEY } from "../components/HiddenColsLock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/glance`;
const hdrs = () => ({
  "Content-Type": "application/json",
  "X-Owner-Password": localStorage.getItem(OWNER_PW_KEY) || "",
});

const call = async (url, opts = {}) => {
  const resp = await fetch(url, { ...opts, headers: hdrs() });
  if (!resp.ok) throw new Error(resp.status === 401 ? "Owner password needed — unlock again." : `HTTP ${resp.status}`);
  return resp.json();
};

export const GLANCE_EVENT = "glance-archive-changed";
const ping = () => window.dispatchEvent(new Event(GLANCE_EVENT));

export const listGlance = () => call(API);
export const saveGlance = (snap) => call(API, { method: "POST", body: JSON.stringify(snap) }).then((r) => (ping(), r));
export const deleteGlance = (id) => call(`${API}/${id}`, { method: "DELETE" }).then((r) => (ping(), r));
export const scoreGlance = () => call(`${API}/score`, { method: "POST" }).then((r) => (ping(), r));
